import {
  ChangeDetectionStrategy,
  Component,
  input,
  linkedSignal,
  output,
} from '@angular/core';
import { MatIconModule } from '@angular/material/icon';
import { MatSelectModule } from '@angular/material/select';

@Component({
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [MatSelectModule, MatIconModule],
  selector: 'app-select',
  templateUrl: './select.component.html',
})
export class SelectComponent {
  readonly selectedOption = input<string | undefined>(undefined);
  readonly options = input.required<string[]>();
  readonly icon = input<string | undefined>(undefined);
  readonly linkedSelectedOption = linkedSignal(() => this.selectedOption());
  readonly selectionChange = output<string>();

  onSelectionChange(selectedOption: string): void {
    this.linkedSelectedOption.set(selectedOption);
    this.selectionChange.emit(selectedOption);
  }
}
